/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { slaControllerCreate } from '../fn/sla/sla-controller-create';
import { SlaControllerCreate$Params } from '../fn/sla/sla-controller-create';
import { slaControllerDelete } from '../fn/sla/sla-controller-delete';
import { SlaControllerDelete$Params } from '../fn/sla/sla-controller-delete';
import { slaControllerUpdate } from '../fn/sla/sla-controller-update';
import { SlaControllerUpdate$Params } from '../fn/sla/sla-controller-update';

@Injectable({ providedIn: 'root' })
export class SlaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `slaControllerCreate()` */
  static readonly SlaControllerCreatePath = '/sla';

  /**
   * Crea uno SLA.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `slaControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  slaControllerCreate$Response(params: SlaControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return slaControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea uno SLA.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `slaControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  slaControllerCreate(params: SlaControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.slaControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `slaControllerDelete()` */
  static readonly SlaControllerDeletePath = '/sla/{id}';

  /**
   * Setta uno SLA come inattivo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `slaControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  slaControllerDelete$Response(params: SlaControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return slaControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Setta uno SLA come inattivo.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `slaControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  slaControllerDelete(params: SlaControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.slaControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `slaControllerUpdate()` */
  static readonly SlaControllerUpdatePath = '/sla/{id}';

  /**
   * Modifica uno SLA.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `slaControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  slaControllerUpdate$Response(params: SlaControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return slaControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica uno SLA.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `slaControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  slaControllerUpdate(params: SlaControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.slaControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

}
